import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=fc8ce188&scoped=true"
import script from "./ScrollView.vue?vue&type=script&lang=js"
export * from "./ScrollView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ce188",
  null
  
)

export default component.exports